import { useMutation } from "@tanstack/react-query";
import clienteAxios from "../../helpers/clienteAxios";
import { toast } from "react-toastify";
import { useLoading } from "../../context/loadingContext";
import Swal from "sweetalert2";

const apiValidarRut = async (datos) => {

  const { data } = await clienteAxios.post(
    '/sucursalVirtual/checkRut', datos
  );
  return data;
};

const useValidarRut = () => {
  const { setLoading, removeLoading } = useLoading();
  return useMutation(apiValidarRut, {
    onSuccess: (response) => {
      removeLoading({id:"rutValidate"});
    },
    onError: (error) => {
      removeLoading({id:"rutValidate"});
      Swal.fire({
        icon: "error",
        title: error.response.data.error.detalleRespuesta,
        html: `<p></p>`,
        confirmButtonText: 'Volver',
        focusConfirm: false,
        iconColor: 'red',
        width: '40rem',
        customClass: {
          popup: 'containerSwal',
          title: 'titleSwal',
          closeButton: '...',
          icon: 'iconSwal',
          confirmButton: 'buttonSwal',
          denyButton: '...',
          cancelButton: '...',
        }
      });
    },
    onMutate: () => {
      setLoading({
        id:"rutValidate",
        message: "Validando rut...",
      });
    },
  });
};

export default useValidarRut;
